import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './form.css'
import Steps from './Steps'
import { SummaryContainer } from '../Summary'
import { SelectionContainer } from './Selection.js'
import classNames from "classnames"

class Form extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        createCollaborativeIndexation: PropTypes.func.isRequired,
        currentStep: PropTypes.number.isRequired,
        nextStep: PropTypes.func.isRequired,
        previousStep: PropTypes.func.isRequired,
        moveToStep: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        stepsValidation: PropTypes.object.isRequired,
        steps: PropTypes.array.isRequired,
        hasCollaborativeIndexationSelection: PropTypes.bool.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.createCollaborativeIndexation = this.createCollaborativeIndexation.bind(this)
        this.nextStep = this.nextStep.bind(this)
        this.previousStep = this.previousStep.bind(this)
        this.isFormValid = this.isFormValid.bind(this)
        this.goToLastStep = this.goToLastStep.bind(this)
        this.isLastStep = this.isLastStep.bind(this)
        this.handleUserShortcuts = this.handleUserShortcuts.bind(this)

        this.createCollaborativeIndexationButton = React.createRef()
    }

    isFormValid()
    {
        if(! this.props.hasCollaborativeIndexationSelection)
        {
            return false
        }

        let isFormValid = true
        Object.entries(this.props.stepsValidation).forEach(([step, closure]) => {
            if(typeof(closure) !== 'function')
            {
                return true
            }

            try
            {
                closure()
            }
            catch(e)
            {
                isFormValid = false
            }
        })

        return isFormValid
    }

    async createCollaborativeIndexation(event)
    {
        event.preventDefault()

        if(! this.isFormValid())
        {
            return
        }

        await this.props.createCollaborativeIndexation(this.props.fields)
    }

    stepValidation()
    {
        if(! this.props.stepsValidation.hasOwnProperty(this.props.currentStep))
        {
            return
        }

        return this.props.stepsValidation[this.props.currentStep]
    }

    nextStep(event)
    {
        event.preventDefault()
        this.props.nextStep(this.stepValidation())
    }

    previousStep()
    {
        this.props.previousStep()
    }

    steps()
    {
        return [
            SelectionContainer,
            ...this.props.steps,
            SummaryContainer,
        ]
    }

    goToLastStep()
    {
        this.props.moveToStep(this.totalSteps() + 1, this.props.stepsValidation)
    }

    isLastStep()
    {
        return this.props.currentStep === this.totalSteps()
    }

    isGoToLastStepButtonDisplayed()
    {
        return this.isFormValid() &&this.props.currentStep < this.totalSteps() - 1
    }

    currentFormStepComponent()
    {
        if(this.steps().hasOwnProperty(this.props.currentStep - 1))
        {
            return this.steps()[this.props.currentStep - 1]
        }

        return null
    }

    hasPreviousStep()
    {
        return this.props.currentStep > 1
    }

    hasNextStep()
    {
        return this.props.currentStep < this.totalSteps() && this.props.hasCollaborativeIndexationSelection
    }

    totalSteps()
    {
        return Object.keys(this.steps()).length
    }

    handleUserShortcuts(event)
    {
        if(! event.ctrlKey)
        {
            return
        }

        if(event.keyCode === 13)
        {
            event.preventDefault()

            return this.goToLastStep()
        }
    }

    componentDidUpdate()
    {
        if(this.createCollaborativeIndexationButton.current)
        {
            this.createCollaborativeIndexationButton.current.focus()
        }
    }

    render()
    {
        const { t, currentStep } = this.props

        const FormStepComponent = this.currentFormStepComponent()

        if(! FormStepComponent)
        {
            return null
        }

        return (
            <React.Fragment>
                <Steps currentStep={ currentStep } totalSteps={ this.totalSteps() }/>
                <div className='form-wrapper'>
                    <form onKeyDown={ this.handleUserShortcuts }>
                        <div id={'form-fields'}>
                            <FormStepComponent />
                        </div>
                        {
                            (this.hasPreviousStep() || this.hasNextStep() || this.isGoToLastStepButtonDisplayed()) && (
                                <div className={classNames('step-navigation', {'last-step' : this.isLastStep()})}>
                                    {
                                        this.hasPreviousStep() && (
                                            <button
                                                type={ 'button' }
                                                className={'btn primary'}
                                                onClick={ this.previousStep }
                                                title={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.stepNavigation.buttons.previous')}
                                            >
                                                <i className={ 'fa fa-angle-left' }></i>
                                            </button>
                                        )
                                    }
                                    {
                                        this.hasNextStep() && (
                                            <button
                                                type={'submit'}
                                                className={'btn primary'}
                                                onClick={this.nextStep}
                                                title={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.stepNavigation.buttons.next')}
                                            >
                                                <i className={'fa fa-angle-right'}></i>
                                            </button>
                                        )
                                    }
                                    {
                                        this.isGoToLastStepButtonDisplayed() && (
                                            <button
                                                type={'button'}
                                                className={'btn secondary'}
                                                onClick={this.goToLastStep}
                                                title={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.stepNavigation.buttons.last')}
                                            >
                                                <i className={'fa fa-angle-double-right'}></i>
                                            </button>
                                        )
                                    }
                                    {
                                        this.isLastStep() && (
                                            <button
                                                ref={this.createCollaborativeIndexationButton}
                                                type="submit"
                                                className="btn primary"
                                                onClick={this.createCollaborativeIndexation}
                                            >
                                                {t('visualizer:common.validate')}
                                            </button>
                                        )
                                    }
                                </div>
                            )
                        }

                    </form>
                </div>
            </React.Fragment>
        )
    }
}

export default withTranslation()(Form)
